
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Content } from '@/types/content';
import moment from 'moment';

@Component
export default class ContentListTile extends Vue {
  @Prop() content!: Content;

  get published(): boolean {
    return this.content.meta!.live_commit !== null;
  }

  get publishedDate(): string {
    return this.fromNow(this.content.published_at as string);
  }

  get updatedDate(): string {
    return this.fromNow(this.content.updated_at);
  }

  get imageExists(): boolean {
    return (
      this.content.meta!.image !== null && this.content.meta!.image!.id !== null
    );
  }

  get imageUrl(): string {
    if (this.content.meta!.image!.path.startsWith('http')) {
      return this.content.meta!.image!.path;
    }
    return `https://cdn.alternativebusinessfunding.co.uk/131x64/smart/${
      this.content.meta!.image!.path
    }`;
  }

  get isHubPage(): boolean {
    return this.content.id === this.content.category!.content_page_id;
  }

  fromNow(fromDate: string): string {
    moment.locale('en-gb');
    const fromMoment: moment.Moment = moment(fromDate);
    const now: moment.Moment = moment();
    return now.diff(fromMoment, 'days') > 1
      ? fromMoment.calendar()
      : fromMoment.fromNow();
  }
}
